module.exports = __webpack_public_path__ + "img/amministrazione.d5fa7ccf.svg";